import styled from '@emotion/styled';
import ToggleSwitch from '~/theseus/components/ToggleSwitch';


export default styled(ToggleSwitch)`
  margin-left: 80px;
  &:before {
    content: '\\2714  Enabled';
    position: absolute;
    align-self: center;
    font-size: 12px;
    transition: opacity 300ms ease;
    opacity: 0;
    font-weight: 700;
    width: 70px;
    right: 50px;
  }

  &[aria-pressed="true"] {
    &:before {
      opacity: 1;
    }
  }
`;
